import type { ApiService } from "../types/domain";

export const links = {
  myAccount: "https://myaccount.kitsos.net",
  limitIncrease: "https://myaccount.kitsos.net/limits",
  status: "https://status.kitsos.net",
  docs: "https://docs.kitsos.net",
  privacy: "https://kitsos.net/privacy",
  pushActivation: "https://app.kitsos.net/preferences/notifications"
} as const;

export const apiServices: ApiService[] = [
  { id: "mail", name: "Mail API", descriptionKey: "service.mail.description", baseUrl: "https://mail.api.kitsos.net/v1", docsUrl: "https://docs.api.kitsos.net/mail/", authMethod: "Kitsos API key", status: "unknown" },
  { id: "verify", name: "Verify API", descriptionKey: "service.verify.description", baseUrl: "https://verify.api.kitsos.net/v1", docsUrl: "https://docs.api.kitsos.net/verify/", authMethod: "Kitsos API key", status: "unknown" },
  { id: "hide-my-email", name: "Hide My Email", descriptionKey: "service.hme.description", baseUrl: "https://hme.api.kitsos.net/v1", docsUrl: "https://docs.api.kitsos.net/hme/", authMethod: "Kitsos API key", status: "unknown" },
  { id: "utility", name: "Utility API", descriptionKey: "service.utility.description", baseUrl: "https://utility.api.kitsos.net/v1", docsUrl: "https://docs.api.kitsos.net/utility/", authMethod: "Kitsos API key", status: "unknown" },
  { id: "dns-hosting", name: "DNS Hosting API", descriptionKey: "service.dns.description", baseUrl: "https://dns.api.kitsos.net/v1", docsUrl: "https://docs.api.kitsos.net/dns-hosting", authMethod: "Kitsos API key", status: "unknown" },
  { id: "keys", name: "Keys API", descriptionKey: "service.keys.description", baseUrl: "https://keys.api.kitsos.net/v1", docsUrl: "https://docs.api.kitsos.net/keys/", authMethod: "Clerk session", status: "unknown" }
];

export const env = {
  consentApi: "https://consent.api.kitsos.net",
  betterStackToken: import.meta.env.VITE_BETTERSTACK_TOKEN?.trim() || "",
  keysApiBaseUrls: ["https://keys.api.kitsos.net/v1", "/api/keys"] as const,
  notificationApiBaseUrls: ["https://notification.api.kitsos.net/v1", "/api/notifications"] as const,
  serviceHealthUrl: "/api/service-health",
  fixtures: import.meta.env.DEV && import.meta.env.VITE_ENABLE_DEV_FIXTURES === "true"
};
